import { useQuery } from '@tanstack/react-query'
import { Navigate, useLocation } from 'react-router-dom'
import { api } from '../../lib/api'
import type { OnboardingStatusResponse } from '../../lib/onboarding'

/**
 * Hard-redirect approved merchants to the setup wizard only while the first
 * store is still missing. Later go-live steps are soft-guided via the dashboard
 * checklist / wizard — not a forced redirect.
 */
export default function OnboardingSetupRedirect() {
  const location = useLocation()

  const { data: status, isLoading } = useQuery({
    queryKey: ['onboarding-status'],
    queryFn: async () => {
      const res = await api.get<OnboardingStatusResponse>('/me/onboarding-status')
      return res.data
    },
    staleTime: 30_000,
  })

  if (isLoading || !status || status.complete) return null

  const path = location.pathname
  if (path.startsWith('/onboarding')) return null

  const storeStep = status.steps.find((s) => s.key === 'store')
  const storeIncomplete = storeStep ? !storeStep.complete : true
  if (!storeIncomplete) return null

  return <Navigate to="/onboarding" replace />
}
